<template>
    <section class="automation page__section automation vidget_wrap">
        <h1 class="page__h1 automation__h1 detectMobVisibility">
            <span class="textHide">
                <span>{{ $t('software.title') }}</span>
            </span>
        </h1>
        <div class="automation__list detectMobVisibility">
            <div class="automation__item" data-anim="1">
                <div class="automation__image">
                    <svg
                        width="352"
                        height="270"
                        viewBox="0 0 352 270"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M266.308 24.3317C314.557 28.718 351.5 69.172 351.5 117.62C351.5 164.84 313.22 203.12 266 203.12H5.12777C3.38524 203.12 2.83186 202.939 2.28211 202.645C1.71739 202.343 1.27718 201.902 0.975173 201.338C0.681163 200.788 0.5 200.235 0.5 198.492V4C0.5 2.07375 2.05609 0.51094 3.97978 0.500057L4.0066 0.502403L4.15103 0.51528L4.7183 0.566347C5.21793 0.611435 5.95754 0.678345 6.92117 0.765626C8.84842 0.940186 11.6715 1.19621 15.2625 1.52206C22.4445 2.17377 32.6978 3.10477 44.9985 4.22198C69.5997 6.4564 102.39 9.43562 135.177 12.4148C167.963 15.3941 200.746 18.3733 225.332 20.6077L255.04 23.3076L263.363 24.0641L265.556 24.2634L266.118 24.3145L266.26 24.3274L266.296 24.3307L266.305 24.3315C266.307 24.3316 266.308 24.3317 266.353 23.834L266.308 24.3317Z"
                            stroke="#474747"
                        />
                        <path
                            d="M188.5 102.739L160.501 127.768C159.883 128.32 158.935 128.267 158.383 127.649C158.137 127.375 158.001 127.019 158.001 126.65V76.5908C158.001 75.7624 158.672 75.0908 159.501 75.0908C159.87 75.0908 160.226 75.2267 160.501 75.4725L188.5 100.502C189.117 101.054 189.17 102.002 188.618 102.62L188.991 102.953L188.618 102.62C188.581 102.662 188.541 102.701 188.5 102.739Z"
                            stroke="#474747"
                        />
                        <path
                            d="M168.381 208.155L193.36 267.034C193.684 267.797 193.328 268.677 192.565 269.001C192.38 269.079 192.181 269.12 191.979 269.12H142.021C141.193 269.12 140.521 268.448 140.521 267.62C140.521 267.419 140.562 267.219 140.641 267.034L165.62 208.155C165.943 207.392 166.824 207.036 167.586 207.36C167.944 207.512 168.229 207.797 168.381 208.155Z"
                            stroke="#474747"
                        />
                    </svg>
                </div>
                <div class="automation__description">
                    <div class="automation__name">
                        <span>
                            <span>{{ $t('software.asnovator') }}</span>
                        </span>
                    </div>
                    <div class="automation__desc textFade" data-chain="1">
                        <p>{{ $t('software.asnovator_descr1') }}</p>
                        <p>{{ $t('software.asnovator_descr2') }}</p>
                        <p>{{ $t('software.asnovator_descr3') }}</p>
                    </div>
                </div>
                <div class="automation__software-wrapper">
                    <div
                        v-for="(asnovatorList, idx) in $t('software.asnovator_list')"
                        :key="idx"
                        class="automation__software"
                    >
                        <div :class="`automation__software-img${idx + 1}`"></div>
                        <ul class="automation__software-list">
                            <li class="automation__software-item--title">{{ asnovatorList.title }}</li>
                            <li
                                v-for="asnovatorItem in asnovatorList.items"
                                :key="asnovatorItem"
                                class="automation__software-item"
                            >{{ asnovatorItem }}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="automation__item" data-anim="2">
                <div class="automation__image">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="352"
                        height="247"
                        viewBox="0 0 352 247"
                    >
                        <g fill="none" stroke="#000" transform="translate(-1)">
                            <path
                                d="M267.304763 24.3279494L267.304749 24.3279482C100.738293 9.19131751 5.0535615.5 5 .5 3.06700338.5 1.5 2.06700338 1.5 4L1.49718962 198.542938C1.39275013 199.523818 1.56050364 200.514513 1.96781985 201.378518 2.26756586 201.921972 2.72353586 202.362943 3.26290853 202.637595 4.14105375 203.050864 5.11478354 203.218421 6.13 203.12L267 203.12C314.220346 203.12 352.5 164.840346 352.5 117.619967 352.503197 69.1689696 315.557051 28.7115375 267.304763 24.3279494zM170.864337 209.915843L170.864281 209.915719C170.713962 209.582724 170.447276 209.316038 170.115476 209.166256 169.361556 208.8283 168.476295 209.163626 168.135663 209.915843L152.734995 244.007316C152.646991 244.200456 152.600978 244.410074 152.6 244.62 152.6 245.448427 153.271573 246.12 154.1 246.12L184.890196 246.12C185.104968 246.120084 185.317253 246.074046 185.513744 245.984524 186.266374 245.643705 186.6017 244.758444 186.264337 244.005843L170.864337 209.915843z"
                            />
                            <path
                                d="M157.650371 112.76758C157.507844 112.667545 157.351234 112.589355 157.197697 112.539322 156.814777 112.42564 156.402328 112.469381 156.05177 112.66085 155.701211 112.85232 155.441499 113.175703 155.329818 113.560623L136.621172 177.395917C136.570036 177.576949 136.549121 177.765179 136.558517 177.941522 136.589153 178.338429 136.776306 178.70688 137.078755 178.965721 137.381205 179.224561 137.774141 179.352559 138.172284 179.321425L238.245427 171.751197C238.393014 171.740967 238.528495 171.665904 238.61475 171.54713 238.692751 171.439198 238.724475 171.30461 238.702887 171.173204 238.681299 171.041799 238.608183 170.924434 238.498284 170.846081L157.650371 112.76758zM192.953484 120.121613C192.967859 120.12045 192.982368 120.119903 192.996978 120.119991L193 119.62 192.893418 120.108508 192.953484 120.121613zM248.113413 134.25L248.73 134.25 248.73 133.75 248.240785 133.646712 248.113413 134.25zM267.866826 67.6764434L261.767337 126.291534C261.749813 126.460653 261.762378 126.631539 261.805713 126.80133 262.001793 127.603883 262.809907 128.096799 263.611592 127.904223L282.796271 123.228215C283.180636 123.121527 283.506675 122.866135 283.702306 122.518504 283.897936 122.170873 283.947044 121.759637 283.838376 121.374307L268.841415 67.5947644C268.772919 67.3683183 268.555091 67.2208713 268.319406 67.2414182 268.084833 67.2618681 267.896478 67.4431592 267.866826 67.6764434zM102.779479 74.686313C102.643885 74.5669477 102.488895 74.4711266 102.307555 74.3971828 101.555628 74.0642225 100.675808 74.3987546 100.339666 75.1367414 97.9596504 80.6974028 95.9177598 85.4665018 94.2146192 89.4431007 93.6185177 90.8349157 93.107338 92.0282542 92.6811583 93.0229989 92.2548967 94.0178699 92.2548967 94.0178699 92.173721 94.2069834 91.864738 94.9732651 92.2336035 95.8451289 92.9970957 96.1563242L144.921119 117.107968C145.143848 117.2001 145.400605 117.120215 145.53175 116.917983 145.662894 116.715751 145.631093 116.448741 145.451006 116.278055L102.779479 74.686313zM59.269548 87.38L59.2381095 87.38 59.1173691 87.3054703C58.9207111 87.1840789 58.666483 87.2132823 58.5024728 87.376104 58.3384626 87.5389257 58.3074111 87.7929347 58.4260368 87.988289L112.925341 176.707159C113.047786 176.905306 113.214694 177.072214 113.413471 177.195049 114.115817 177.630505 115.038068 177.415872 115.475748 176.715406L139.553668 138.10877C139.986416 137.402519 139.764816 136.479185 139.05964 136.046864L59.269548 87.38zM93.0263837 160.57L93.6 160.57 93.6 160.07 93.1046796 160.001752 93.0263837 160.57zM254.025456 169.173234C253.74994 170.212489 253.967291 171.322157 254.617202 172.18139 255.279006 173.056347 256.31277 173.570378 257.41 173.57L277.420081 173.570102C278.144222 173.584705 278.775371 173.079786 278.920223 172.369407L284.260723 146.367004C284.391728 145.744672 284.455194 145.11002 284.45 144.47 284.45 142.0194 283.476503 139.669169 281.743667 137.936333 280.010831 136.203497 277.6606 135.23 275.209798 135.23 268.361204 135.227234 262.344985 139.775986 260.481208 146.365791L254.081208 169.045791 254.034122 169.158069 254.025456 169.173234zM182.709834 104.952213L182.709705 104.952184 228.509728 115.252189C241.035975 118.069837 253.559047 110.521447 256.917478 98.1289574 258.475969 92.3903115 257.688675 86.2674725 254.729099 81.1097734 251.769523 75.9520743 246.880573 72.1828363 241.140013 70.6328079L240.630947 70.4956196 194.173785 59.1063065C193.368153 58.9137802 192.558962 59.4107105 192.364925 60.2218529L181.584834 103.122213C181.485978 103.514389 181.549679 103.929867 181.761489 104.274412 181.9733 104.618957 182.315269 104.863369 182.709834 104.952213zM170.01903 97.2021094L170.019092 97.2019356 186.429271 51.2214342C186.571266 50.8249058 186.540008 50.3869483 186.343137 50.0146055 186.146267 49.6422627 185.801923 49.3698444 185.394394 49.263966L142.393765 38.1038023C130.277974 34.9425133 117.63848 40.9192001 112.394023 52.2894355 110.104052 57.2537299 109.882377 62.9249385 111.777867 68.0528332 113.673356 73.180728 117.530379 77.3442753 122.486336 79.6201607L123.367679 79.9965601 168.03903 98.0871094C168.418232 98.2419636 168.844266 98.235012 169.218214 98.0678686 169.592162 97.9007252 169.881493 97.5879302 170.01903 97.2021094z"
                            />
                        </g>
                    </svg>
                </div>
                <div class="automation__description">
                    <div class="automation__name">
                        <span>
                            <span>{{ $t('software.api') }}</span>
                        </span>
                    </div>
                    <div class="automation__desc textFade" data-chain="2">
                        <strong>{{ $t('software.api_title1') }}</strong>
                        <br />
                        {{ $t('software.api_descr1') }}
                        <br />
                        <br />

                        <strong>{{ $t('software.api_title2') }}</strong>
                        <br />
                        {{ $t('software.api_descr2') }}
                        <br />
                        <br />

                        <strong>{{ $t('software.api_title3') }}</strong>
                        {{ $t('software.api_descr3') }}
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import params from "../../public/site_config.json";

export default {
    data: function() {
        return {
            asnovator_link: params.asnovator_link,
            effie_link: params.effie_link
        };
    },
    methods: {},
    mounted() {
        var _this = this,
            minWidth = $(window).width();

        $(window).on("mousewheel DOMMouseScroll", function(e) {
            let section = $(".fp-section.active");

            if (section.hasClass("autoBox")) {
                if (minWidth >= 1024) {
                    _this.actWithViewport();
                }

                if (
                    $(".hideTop", section).offset().top <
                    $(window).scrollTop() + $(window).height()
                ) {
                    $("body").addClass("hideTopBar");
                } else {
                    $("body").removeClass("hideTopBar");
                }
            }
        });
    }
};
</script>

<style lang="stylus" scoped>
.automation {
    padding: 0;
    background: #222;

    .automation__h1 {
        display: none;
    }
}

.automation__list .automation__item {
    padding: 197px 29px 100px 16px;
    position: relative;
    color: #fff;

    @media (min-width: 1024px) {
        padding-left: 116px;
        display: flex;
        flex-flow: wrap;
    }

    .automation__image {
        width: 191px;
        height: 146px;
        margin: 0 auto 40px auto;

        @media (min-width: 1024px) {
            width: 355px;
            height: 270px;
            margin: 0 116px 0 auto;
        }

        svg {
            width: 100%;
            height: 100%;

            path {
                stroke: #474747;
            }
        }
    }
}

.automation__item[data-anim='2'] {
    background: #fff;
    color: #000;

    .automation__image {
        margin-bottom: 80px;
    }
}

.automation__description {
    @media (min-width: 1024px) {
        width: 347px;
        margin-right: auto;
    }
}

.automation__name {
    font-size: 24px;
    line-height: 1.3;
    padding: 16px 0;
    position: relative;
}

.automation__item[data-anim='1'] .automation__name {
    display: none;

    @media (min-width: 1024px) {
        display: block;
    }

    @media (min-width: 1366px) {
        font-size: 48px;
        font-weight: bold;
    }
}

.automation__desc {
    line-height: 1.7;
}

.automation__software-wrapper {
    margin-top: 80px;
    position: relative;

    @media (min-width: 1024px) {
        width: 100%;
        margin-top: 180px;
        display: grid;
        grid-template-rows: repeat(2, 172px);
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 60px;
    }
}

.automation__software-wrapper:before {
    width: 22px;
    height: 488px;
    display: block;
    position: absolute;
    top: 50%;
    left: 100px;
    transform: translateY(-50%) scale(1.1);
    background: url('~@/assets/images/svg/automation_mob.svg') center no-repeat;
    content: '';

    @media (min-width: 1024px) {
        width: 976px;
        height: 354px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(1.1);
        background: url('~@/assets/images/svg/automation.svg') center no-repeat;
    }
}

.automation__software {
    display: flex;
    align-items: center;

    @media (min-width: 1024px) {
        width: 190px;
        align-items: start;
        position: relative;
    }

    div {
        width: 50px;
        height: 50px;
        margin-right: 115px;

        @media (min-width: 1024px) {
            width: 100px;
            height: 100px;
            margin: 0;
        }
    }

    .automation__software-img1 {
        background: url('~@/assets/images/svg/1c.svg') center / 50px 50px no-repeat;

        @media (min-width: 1024px) {
            background-size: 100px 100px;
        }
    }

    .automation__software-img2 {
        background: url('~@/assets/images/svg/bitrix.svg') center / 50px 50px no-repeat;

        @media (min-width: 1024px) {
            background-size: 100px 100px;
        }
    }

    .automation__software-img3 {
        background: url('~@/assets/images/svg/bi.svg') center / 50px 50px no-repeat;

        @media (min-width: 1024px) {
            background-size: 100px 100px;
        }
    }

    .automation__software-img4 {
        background: url('~@/assets/images/svg/web.svg') center / 50px 50px no-repeat;

        @media (min-width: 1024px) {
            background-size: 100px 100px;
        }
    }
}

.automation__software:not(:last-child) {
    margin-bottom: 50px;
}

.automation__software:nth-child(1) {
    @media (min-width: 1024px) {
        margin: 0 auto;
    }
}

.automation__software:nth-child(2) {
    @media (min-width: 1024px) {
        margin: 0;
    }
}

.automation__software:nth-child(3) {
    @media (min-width: 1024px) {
        margin: 0 0 0 auto;
    }
}

.automation__software:nth-child(4) {
    @media (min-width: 1024px) {
        margin: 0 auto;
    }
}

.automation__software-list {
    width: 140px;
    line-height: 32px;

    @media (min-width: 1024px) {
        position: absolute;
        top: 54px;
        left: 50px;
    }
}

.automation__software-item--title {
    font-size: 24px;
}

.automation__software-item {
    font-size: 14px;
    color: #808080;
}
</style>